import * as React from 'react';
import { useSelector } from 'react-redux';
import { UpgradeColumnFeatures } from './UpgradeColumnFeatures';
import { orgPayPeriodSelector } from '../../../redux/app/selectors/organization';
import { v4PlanPrices } from '../../../constants/pricing';

interface UpgradeColumnProps {
  columnData: Record<string, any>;
  showFeatures: boolean;
  selected: string;
  setSelected: (id: string) => void;
  checkoutSummaryRef: any;
}
export const UpgradeColumn = ({
  columnData, showFeatures, selected, setSelected, checkoutSummaryRef,
}: UpgradeColumnProps) => {
  const payPeriod = useSelector(orgPayPeriodSelector);
  const { id, name, nameColor, featureSections } = columnData;

  const isTrialPlan = id === 'trial-plan-4';
  const isLitePlan = id === 'lite-plan-4';
  const isStandardPlan = id === 'standard-plan-4';
  const isCustomPlan = id === 'custom';

  const handleClick = () => {
    if (isLitePlan) return;
    const { classList } = checkoutSummaryRef.current;
    if (isCustomPlan) {
      classList.add('hide');
    } else {
      classList.remove('hide');
    }

    setSelected(id);
  };

  const planNameClass = `${nameColor} center fsz-15 uppercase letter-space-3`;
  const key = isTrialPlan ? id : `${id}-${payPeriod}`;
  const planPrices = v4PlanPrices[key];

  let placeholder;
  let bigPrice;
  let subtitle;

  switch (id) {
    case 'lite-plan-4':
    case 'standard-plan-4':
      bigPrice = (
        <p className="mt-5">
          <span className="black mt-10 fsz-28 center bold-900">
            {`$${planPrices.seatPrice}`}
          </span>
          <span className="fsz-16 bold-900">/mo</span>
          &nbsp;
          <span className="fsz-16">per user</span>
        </p>
      );
      subtitle = isStandardPlan ? (
        <p className="fsz-16 center">
          Plus&nbsp;
          <span className="bold-900">{`$${planPrices.platformPrice}`}</span>
          <span className="bold-900">/mo </span>
          platform fee
        </p>
      ) : <></>;
      placeholder = <div className="empty-placeholder" />;
      break;
    case 'custom':
      bigPrice = <span className="black mt-5 fsz-28 center bold-900">Custom</span>;
      subtitle = <p>Contact Us</p>;
      placeholder = <div className="empty-placeholder" />;
      break;
  }

  return (
    <div
      tabIndex={0}
      role="button"
      onClick={handleClick}
      onKeyPress={handleClick}
      className={`column width-fill ${isStandardPlan ? 'standard' : ''}`}
    >
      <div className="container-top">
        <div className={`upgrade-option row-1 ${selected === id && !isLitePlan ? 'selected' : ''}`}>
          <div className="text-container">
            <h2 className={planNameClass}>{name}</h2>
            {bigPrice}
            {subtitle}
          </div>
          {isLitePlan ? <p className="current-banner fsz-15">Current</p> : placeholder}
        </div>
      </div>
      {
        showFeatures && (
          <div className="px-10">
            <UpgradeColumnFeatures featureSections={featureSections} />
            <br />
            <p>And more</p>
          </div>
        )
      }
    </div>
  );
};
